export const subscriptionLabels: Record<string, string> = {trial: 'Пробный период', active: 'Подписка активна', grace: 'Льготный период', restricted: 'Доступ ограничен'};
export function subscriptionDate(value: string, locale: string): string {
    return value ? new Date(value).toLocaleString(locale === 'en' ? 'en-US' : 'ru-RU', {year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'}) : '—';
}

export const limitStrLength = function (text: string, maxLength: number): string {
    if (text.length > maxLength - 3) {
        return text.substring(0, maxLength).trimEnd() + "...";
    } else return text;
};


export function prefixObj(obj: any, prefix: any): any {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
            const data = [`${key}`, typeof value === "object" ? prefixObj(value, prefix) : value];
            data[0] = data[0] + "[0]";
            return data;
        }),
    );
}

export function isObjectsEqual(obj1: Record<any, any>, obj2: Record<any, any>):boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = obj1[key];
        const val2 = obj2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !isObjectsEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
            return false;
        }
    }
    return true;
}

export function isObject(object: Record<any, any>): any {
    return object != null && typeof object === "object";
}
